import {
  forwardRef,
  // eslint-disable-next-line bh/banned-chakra-import
  Link as BaseLink,
  LinkProps as BaseLinkProps,
} from "@chakra-ui/react";
import React from "react";

import { useForwardedRef } from "../../hooks/useForwardedRef";
import { GAEventDetails, useSendGAEvent } from "../../utils/googleAnalytics";
import { getEventValues } from "../Buttons/utils";

type LinkProps = BaseLinkProps & {
  /** Details to be passed to `sendGaEvent`. See component description for default values  */
  bhEvent?: GAEventDetails;
};

/**
 * Wrapper around the chakra `<Link />` that sends ga events on click.
 *
 * You can use the `bhEvent` prop to control the ga event details.
 * The following defaults are applied:
 *  - action defaults `"click"`
 *  - label defaults to `data-testid` attribute (if present), or the link's inner text
 */
export const Link = forwardRef<LinkProps, "a">(
  ({ bhEvent, onClick, ...props }, forwardedRef) => {
    const sendGaEvent = useSendGAEvent();
    const ref = useForwardedRef<HTMLAnchorElement>(forwardedRef);

    return (
      <BaseLink
        {...props}
        ref={ref}
        onClick={(e) => {
          const { action, category, label, params, value } = getEventValues({
            el: ref.current,
            componentType: "link",
            providedParams: bhEvent,
          });

          sendGaEvent(action, category, label, value, params);
          onClick?.(e);
        }}
      />
    );
  }
);
